import { ActivatedRoute } from '@angular/router';

import {
    createTab as createHiTab,
    HiTabConfig,
} from '../human-insight/human-insight.model';
import { InsightTabConfig } from '../insight-explorer/insight-explorer.model';
import { epicDependencies } from '../store';
import { User } from '../user/user.model';

import { Command } from './command/command';
import { Tab } from './experimental.tabset';
import { TabContext } from './tabset.model';

/* TODO move */
interface Options {
    tabs: Array<Tab<TabContext<InsightTabConfig>>>;
    selectedTab: string;
}

/* TODO rename */
export function overrideInsight(opts: Options): Options {
    try {
        // TODO FIXME. this can be done better
        const service =
            epicDependencies.injector.get<ActivatedRoute>(
                ActivatedRoute,
            ).snapshot;

        const commandB64 = service.queryParamMap.get('insightCommand');
        const params = new URLSearchParams(atob(commandB64));
        const commandStr = params.get('command');

        switch (commandStr.toLowerCase()) {
            case Command.OPEN_HUMAN_INSIGHT_TAB.toLowerCase():
                return navigateToHumanInsight(params, opts);
        }
    } catch {
        return opts;
    }
}

function navigateToHumanInsight(
    params: URLSearchParams,
    opts: Options,
): Options {
    const userId = parseInt(params.get('userId'));

    let nextTabs = opts.tabs;
    let nextTab = nextTabs.find(
        (e: Tab<TabContext<HiTabConfig>>) => e.ctx?.config?.userId === userId,
    );
    if (nextTab == null) {
        const user = new User();
        user.id = userId;
        user.lastName = params.get('username') ?? 'unknown';
        nextTab = createHiTab(user);
        nextTabs = [...opts.tabs];
        nextTabs.splice(opts.tabs.length - 1, 0, nextTab);
    }
    return {
        selectedTab: nextTab.id,
        tabs: nextTabs,
    };
}
